<template>
    <div class="customer">
        <el-form :model="searchData" :inline="true" size="small">
            <el-form-item>
                <el-select size="small" v-model="searchData.user_id" placeholder="销售员" clearable>
                    <el-option
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        v-for="item in userData.list"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input
                    v-model="searchData.name"
                    placeholder="客户名称/联系人"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-cascader
                    v-model="searchData.area"
                    :options="areaData.list"
                    :props="{ checkStrictly: true }"
                    clearable
                    filterable
                    placeholder="所在地区"
                ></el-cascader>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="SearchCooperation"
                    >搜索</el-button
                >
            </el-form-item>
        </el-form>
        <div class="card">
            <div class="list" v-loading="cooperationData.loading.list">
                <el-row class="list-control">
                    <el-col :span="24">
                        <el-radio-group
                            size="small"
                            v-model="searchData.customer_type_id"
                            @change="SearchCooperation"
                        >
                            <el-radio-button :label="1">经销商</el-radio-button>
                            <el-radio-button :label="2">代理商</el-radio-button>
                        </el-radio-group>
                    </el-col>
                </el-row>
                <div class="list-table">
                    <el-table :data="cooperationData.list" stripe style="width: 100%">
                        <el-table-column label="名称" width="240">
                            <template slot-scope="scope">
                                <el-link
                                    type="primary"
                                    :underline="false"
                                    @click="DetailCooperation(scope.row)"
                                    >{{ scope.row.customer.contact_name
                                    }}{{
                                        scope.row.customer.name === scope.row.customer.contact_name
                                            ? null
                                            : '（' + scope.row.customer.name + '）'
                                    }}</el-link
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="经营地区">
                            <template slot-scope="scope">
                                <template v-for="(row, index) in scope.row.area">
                                    <span :key="index"
                                        >{{ row[0] }}{{ row[1] }}{{ row[2]
                                        }}{{ scope.row.area[index + 1] ? '、' : null }}</span
                                    >
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="申请时间" width="180">
                            <template slot-scope="scope">{{ scope.row.updated_at }}</template>
                        </el-table-column>
                        <el-table-column label="申请人" width="120">
                            <template slot-scope="scope">{{ scope.row.user.name }}</template>
                        </el-table-column>
                        <el-table-column label="状态" width="120">
                            <template slot-scope="scope">{{
                                scope.row.status
                                    ? scope.row.status === 1
                                        ? '审核通过'
                                        : '审核未通过'
                                    : '待审核'
                            }}</template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="list-pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :current-page.sync="cooperationData.pages.page"
                        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                        :page-size="cooperationData.pages.pagesize"
                        :total="cooperationData.pages.total"
                        @size-change="GetSize"
                        @current-change="GetCurrent"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <v-CooperationDetail
            :detailParam="componentParam.cooperationDetail"
            v-if="componentParam.cooperationDetail.visible"
        />
    </div>
</template>

<script>
import { UserData } from '@/plugin/User'
import { AreaData } from '@/plugin/Area'
import CooperationDetail from '@/components/cooperation/Detail'
export default {
    components: {
        'v-CooperationDetail': CooperationDetail
    },
    inject: ['reload'],
    mixins: [UserData, AreaData],
    data() {
        return {
            userData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999
                }
            },
            searchData: {
                customer_type_id: 1,
                name: null,
                area: []
            },
            cooperationData: {
                loading: {
                    list: false
                },
                list: [],
                pages: {
                    page: 1,
                    pagesize: 10,
                    total: 0
                }
            },
            componentParam: {
                cooperationDetail: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetUser()
        })
    },
    mounted() {
        this.$nextTick(() => {
            this.GetCooperation()
        })
    },
    methods: {
        // 员工
        GetUser() {
            this.GetUserData({
                data: {
                    order: 'asc',
                    ...this.userData.pages
                }
            }).then(res => {
                this.userData.list = res.list
            })
        },
        // 查询
        SearchCooperation() {
            this.cooperationData.pages.page = 0
            switch (this.searchData.area.length) {
                case 1:
                    this.searchData.area[1] = this.searchData.area[2] = this.searchData.area[0]
                    break
                case 2:
                    this.searchData.area[2] = this.searchData.area[1]
                    break
            }
            this.GetCooperation()
        },
        // 合作客户列表
        GetCooperation() {
            this.cooperationData.loading.list = true
            this.$request({
                url: '/api/v1/customer_user_all',
                params: {
                    ...this.searchData,
                    ...this.cooperationData.pages
                }
            }).then(res => {
                this.cooperationData.loading.list = false
                if (!res.status) {
                    res.data.list.forEach(row => {
                        row.area = JSON.parse(row.area)
                    })
                    this.cooperationData.list = res.data.list
                    this.cooperationData.pages.total = parseInt(res.data.total)
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        GetSize(val) {
            this.cooperationData.pages.pagesize = val
            this.GetCustomer()
        },
        GetCurrent(val) {
            this.cooperationData.pages.page = val
            this.GetCustomer()
        },
        DetailCooperation(row) {
            this.componentParam.cooperationDetail = {
                visible: true,
                row: {
                    customer_id: row.customer.id
                }
            }
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/list.less';
</style>
